import { FeatureSet } from './feature-set';
import {
  PremiumFeature,
  Product,
  ProductInterval,
  ProductName,
  ProductShortName,
  MemberPriceObject,
} from './types';

/**
 * @see https://bitbucket.org/trello/server/src/main/app/data/features.js#lines-7
 */
export const trelloGoldFromBCFeatures: Set<PremiumFeature> = new Set([
  'additionalStickers',
  'customStickers',
  'additionalBoardBackgrounds',
  'customBoardBackgrounds',
  'largeAttachments',
  'customEmoji',
  'savedSearches',
  'butler',
]);

/**
 * @see https://bitbucket.org/trello/server/src/main/app/data/features.js#lines-18
 */
export const trelloGoldFeatures: Set<PremiumFeature> = new Set([
  ...trelloGoldFromBCFeatures,
  'crown',
  'readSecrets',
  'threePlugins',
]);

export const products: Map<number, Product> = new Map([
  [
    10,
    {
      shortName: ProductShortName.TrelloGoldFromBC,
      name: ProductName.TrelloGoldFromBC,
      features: trelloGoldFromBCFeatures,
    },
  ],
  [
    37,
    {
      shortName: ProductShortName.TrelloGoldMonthly,
      name: ProductName.TrelloGoldMonthly,
      interval: ProductInterval.Monthly,
      price: 5,
      features: trelloGoldFeatures,
      yearlyEquivalent: 38,
    },
  ],
  [
    38,
    {
      shortName: ProductShortName.TrelloGoldYearly,
      name: ProductName.TrelloGoldYearly,
      interval: ProductInterval.Yearly,
      price: 45,
      features: trelloGoldFeatures,
    },
  ],
]);

class MemberFeatureSet extends FeatureSet {
  currentProducts = {
    monthly: 'trelloGoldMonthly',
    yearly: 'trelloGoldYearly',
  };

  /**
   * Use price quotes endpoints to get pricing information
   *
   * @deprecated
   */
  currentPriceObjectForModel = (): MemberPriceObject => {
    const monthlyProduct = this.currentProducts.monthly;
    const yearlyProduct = this.currentProducts.yearly;

    const monthlyProductPrice = this.getPrice(monthlyProduct)!;
    const yearlyProductPrice = this.getPrice(yearlyProduct)!;

    return {
      monthly: {
        productNumber: this.getProductNumber(monthlyProduct)!,
        price: monthlyProductPrice,
        monthlyPrice: monthlyProductPrice,
      },
      yearly: {
        productNumber: this.getProductNumber(yearlyProduct)!,
        price: this.getPrice(yearlyProduct)!,
        monthlyPrice: yearlyProductPrice && yearlyProductPrice / 12,
        savePercent: this.getYearlyDiscountPercent(
          yearlyProduct,
          monthlyProduct,
        )!,
      },
      billingStrategy: {
        flatRate: true as const,
      },
    };
  };

  constructor(memberProducts: Map<number, Product>) {
    super(memberProducts);
  }
}

export const MemberFeatures = new MemberFeatureSet(products);
